module.exports = __webpack_public_path__ + "img/assess-180.51c948c.svg";